<template>
    <modal :autoshow="true" size="m" ref="modal" @close="$emit('close')" :is-closeable="isCloseable" :has-child-overlay="true">
        <template v-slot:title>
            Edit Security User
        </template>

        <template v-slot:subheading>
            <div class="">
                <div class="p-1 unpad-x bg-150 rounded">
                    <div><span class="text-muted">User:</span> {{ securityProfile.first_name }} {{ securityProfile.last_name }}</div>
                </div>
            </div>
        </template>

        <slot>
            <form class="mui-form" @submit.prevent="onSubmit()">
                <div class="form-row">
                    <div class="col-12">
                        <form-input v-model="formData.first_name" :errors="errors.first_name" label="First Name" type="text" />
                    </div>
                </div>

                <div class="form-row">
                    <div class="col-12">
                        <form-input v-model="formData.last_name" :errors="errors.last_name" label="Last Name" type="text" />
                    </div>
                </div>
            </form>

            <p>
                The email address is not editable - deactivate and create a new Security User. The phone number is editable by the user directly under their Profile.
            </p>
        </slot>

        <template v-slot:footer>
            <form-errors :errors="formErrors"/>

            <button-row stacked>
                <button type="button" class="btn btn-outline-primary" @click.prevent="close()">Cancel</button>
                <button type="button" class="btn btn-primary" @click.prevent="onSubmit()">Save</button>
            </button-row>
        </template>
    </modal>
</template>

<script>
import FormMixin from '@/mixins/Form'
import ModalMixin from '@/mixins/ModalMixin'

export default {
    props: ['client', 'securityProfile', ],
    mixins: [FormMixin, ModalMixin],
    computed: {

    },
    data() {
        return {
            formData: this.makeFormData(),
            formRules: {
                first_name: {presence: {allowEmpty: false}, },
                last_name: {presence: {allowEmpty: false}, },
            },
        }
    },
    methods: {
        makeFormData() {
            const data = {
                first_name: this.securityProfile.first_name,
                last_name: this.securityProfile.last_name,
            }

            return data
        },
        onSubmit() {
            this.formErrors = []

            if (!this.validate()) {
                return
            }

            this.$store.dispatch('START_LOADING')
            this.$api.patch(`/clients/${this.client.id}/security-profiles/${this.securityProfile.id}`, this.getFormData()).then(resp => {
                this.$store.dispatch('STOP_LOADING')
                this.$emit('updated', resp)
                this.close()
            }).catch(errors => {
                this.$store.dispatch('STOP_LOADING')
                this.errors = errors
                this.formErrors = errors.__all__
                this.$bus.showError(errors.__all__)
                this.onError()
            })
        },
    },
}
</script>
